// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.21922 1H17.7808L18.7808 5H21V20H22V22H16.5V13H7.5V22H2V20H3V5H5.21922L6.21922 1ZM7.28078 5H16.7192L16.2192 3H7.78078L7.28078 5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 22V15H14.5V22H9.5Z"}}]};

const Dam7FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-7-filled',
    ref,
    icon: element,
  },
));

Dam7FilledIcon.displayName = 'Dam7FilledIcon';

export default Dam7FilledIcon;
